var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6345c11a76b77d7700de1a57_logo-twitter-dark.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 3.33008C15.4 3.63008 14.8 3.73008 14.1 3.83008C14.8 3.43008 15.3 2.83008 15.5 2.03008C14.9 2.43008 14.2 2.63008 13.4 2.83008C12.8 2.23008 11.9 1.83008 11 1.83008C9.3 1.83008 7.8 3.33008 7.8 5.13008C7.8 5.43008 7.8 5.63008 7.9 5.83008C5.2 5.73008 2.7 4.43008 1.1 2.43008C0.8 2.93008 0.7 3.43008 0.7 4.13008C0.7 5.23008 1.3 6.23008 2.2 6.83008C1.7 6.83008 1.2 6.63008 0.7 6.43008C0.7 8.03008 1.8 9.33008 3.3 9.63008C3 9.73008 2.7 9.73008 2.4 9.73008C2.2 9.73008 2 9.73008 1.8 9.63008C2.2 10.9301 3.4 11.9301 4.9 11.9301C3.8 12.8301 2.4 13.3301 0.8 13.3301C0.5 13.3301 0.3 13.3301 0 13.3301C1.5 14.2301 3.2 14.8301 5 14.8301C11 14.8301 14.3 9.83008 14.3 5.53008C14.3 5.43008 14.3 5.23008 14.3 5.13008C15 4.63008 15.6 4.03008 16 3.33008Z",
    fill: "#092540"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b23d0cb7e1882022abdb21446a1d4540.svg";
export { ForwardRef as ReactComponent };